import { Component, Input } from '@angular/core';
import { IconType } from '@dlw-int-mwi/eps-common';

@Component({
  selector: 'app-filter-window',
  templateUrl: './filter-window.component.html',
  styleUrls: ['./filter-window.component.scss']
})
export class FilterWindowComponent {

  @Input() icon?: IconType;
  @Input() titlePart1: string;
  @Input() titlePart2: string;

  constructor() { }

}
